"use client";
import React from "react";
import { motion } from "framer-motion";

const ServicesAboutSection = () => {
  const services = [
    {
      title: "Tradition",
      description: "Be it birthdays, weddings, or baby showers – our handcrafted cakes make every moment memorable.",
      icon: "🎂"
    },
    {
      title: "Quality",
      description: "Everyone deserves dessert! Enjoy our allergen-friendly treats without compromising on taste.",
      icon: "⭐"
    },
    {
      title: "Creativity",
      description: "From rich cheesecakes to decadent brownies, every dessert is a piece of joy.",
      icon: "🎨"
    },
    {
      title: "Passion",
      description: "Be it birthdays, weddings, or baby showers – our handcrafted cakes make every moment memorable.",
      icon: "❤️"
    }
  ];

  return (
    <motion.section
      className="flex overflow-hidden flex-col items-center   pb-20 w-full bg-white"
      initial={{ opacity: 0 }}
      whileInView={{ opacity: 1 }}
      transition={{ duration: 0.8 }}
      viewport={{ once: true }}
      aria-labelledby="services-title"
    >
       <motion.img
               src="https://api.builder.io/api/v1/image/assets/TEMP/bca50df9c6c131b18e6c13e934c23427c496b7e3?placeholderIfAbsent=true&apiKey=d09e0bc02eef4ced83b05308e83d6101"
               alt="Decorative border element"
               className="object-cover w-full h-auto  md:max-h-auto lg:max-h-auto"
               initial={{ y: 50, opacity: 0 }}
               whileInView={{ y: 0, opacity: 1 }}
               transition={{ duration: 0.6, delay: 0.2 }}
               viewport={{ once: true }}
             />
      <motion.h2
        id="services-title"
        className="text-4xl md:text-6xl font-semibold text-red-500 text-center mb-4"
        style={{ fontFamily: "'Sansita Swashed', cursive" }}
        initial={{ scale: 0.8, opacity: 0 }}
        whileInView={{ scale: 1, opacity: 1 }}
        transition={{ duration: 0.6, delay: 0.2 }}
        viewport={{ once: true }}
      >
        Our Services
      </motion.h2>

      <motion.p
        className="text-xl text-cyan-900 text-center mb-12 italic"
        style={{ fontFamily: "'Foolish Talk', cursive" }}
        initial={{ opacity: 0, y: 20 }}
        whileInView={{ opacity: 1, y: 0 }}
        transition={{ duration: 0.6, delay: 0.4 }}
        viewport={{ once: true }}
      >
        A sweet story in every bite.
      </motion.p>

      <motion.div
        className="flex gap-4 md:gap-6 items-center mt-5 justify-center mb-12"
        initial={{ opacity: 0 }}
        whileInView={{ opacity: 1 }}
        transition={{ duration: 0.6, delay: 0.6 }}
        viewport={{ once: true }}
      >
        <img
          src="https://api.builder.io/api/v1/image/assets/TEMP/a004749eeafe96650e9f1ab184dc488f2a5d7166?placeholderIfAbsent=true&apiKey=d09e0bc02eef4ced83b05308e83d6101"
          alt="Decorative line left"
          className="object-contain shrink-0 self-stretch my-auto aspect-[166.67] w-[120px] md:w-[171px]"
        />
        <img
          src="https://api.builder.io/api/v1/image/assets/TEMP/e146accfc39e5657464e52c2fa7da78cc6a7866e?placeholderIfAbsent=true&apiKey=d09e0bc02eef4ced83b05308e83d6101"
          alt="Decorative cupcake element"
          className="object-contain self-stretch my-auto aspect-square w-[25px] md:w-[35px]"
        />
        <img
          src="https://api.builder.io/api/v1/image/assets/TEMP/42135f6d9b1a4837d8746dac7416759042e4672d?placeholderIfAbsent=true&apiKey=d09e0bc02eef4ced83b05308e83d6101"
          alt="Decorative line right"
          className="object-contain shrink-0 self-stretch my-auto aspect-[166.67] w-[120px] md:w-[172px]"
        />
      </motion.div>

      <div className="self-stretch mt-3 mb-0 w-full max-w-6xl mx-auto">
        <div className="overflow-hidden w-full text-center text-slate-500">
          <motion.div
            className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-8 justify-center"
            initial={{ opacity: 0, y: 50 }}
            whileInView={{ opacity: 1, y: 0 }}
            transition={{ duration: 0.8, delay: 0.8 }}
            viewport={{ once: true }}
          >
            {services.map((service, index) => (
              <motion.article
                key={service.title}
                className="flex flex-col items-center p-8 bg-orange-50 rounded-2xl border-2 border-orange-200 hover:border-red-500 transition-all duration-300 hover:shadow-lg"
                initial={{ opacity: 0, y: 30 }}
                whileInView={{ opacity: 1, y: 0 }}
                transition={{ duration: 0.6, delay: 1.0 + index * 0.1 }}
                viewport={{ once: true }}
                whileHover={{ scale: 1.05, y: -5 }}
              >
                <div className="text-5xl md:text-6xl mb-6">
                  {service.icon}
                </div>
                <div className="flex flex-col items-center">
                  <h3
                    className="text-2xl md:text-3xl tracking-wider leading-7 mb-4 text-red-500"
                    style={{ fontFamily: "'Sansita Swashed', cursive" }}
                  >
                    {service.title}
                  </h3>
                  <p className="text-base leading-6 text-center text-cyan-900">
                    {service.description}
                  </p>
                </div>
              </motion.article>
            ))}
          </motion.div>
        </div>
      </div>

      {/* Section Divider */}
      
    </motion.section>
  );
};

export default ServicesAboutSection;
